export function useInsightProject(rptNumber){
  return {
    path: '/insight/project',
    query: { rptNumber }
  }
}

export function useSubMarket({areaCode, cityCode}){
  return {
    path: '/insight/subMarket',
    query: { areaCode, cityCode }
  }
}

export function useUrban({citycode}){
  return {
    path: '/insight/urban',
    query: { cityCode: citycode }
  }
}